import { Box, Button, Paper, TextField, Typography, Grid, useMediaQuery, useTheme, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import useAuth from '../hooks/useAuth';
import axios from "../api/axios"
import { useEffect, useState } from "react";
import InversionistaFind2 from "./InversionistaFind2";
import ExportButtons from "./ExportButtons";

export default function Intervalo2(props) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [inversionista, setInversionista] = useState({ id: 0, label: '' });
    const [inversionistaInput, setInversionistaInput] = useState("")
    const [desde, setDesde] = useState("")
    const [hasta, setHasta] = useState("")
    const { auth } = useAuth();
    const [datos, setDatos] = useState([])
    const [cargando, setCargando] = useState(false)
    const [mensaje, setMensaje] = useState("")

    const esRetiros = props.reporte === 2;
    const titulo = esRetiros ? "Reporte de Retiros" : "Reporte de Ganancias";

    useEffect(() => {
        setDesde(getDesde())
        setHasta(getHasta())
    }, [])

    const getDesde = () => {
        const cual = new Date();
        var mm = cual.getMonth() + 1;
        var yyyy = cual.getFullYear();
        if (mm < 10) { mm = '0' + mm; }
        return yyyy + '-' + mm + '-01';
    }

    const getHasta = () => {
        const cual = new Date();
        var mm = cual.getMonth() + 1;
        var yyyy = cual.getFullYear();
        if (mm == 12) { mm = 1; yyyy++; } else { mm++; }
        let prox = new Date(yyyy, (mm - 1), 1);
        prox.setDate(prox.getDate() - 1)
        mm = prox.getMonth() + 1;
        yyyy = prox.getFullYear();
        let dd = prox.getDate();
        if (mm < 10) { mm = '0' + mm; }
        if (dd < 10) { dd = '0' + dd; }
        return yyyy + '-' + mm + '-' + dd;
    }

    const handleClick = async () => {
        setCargando(true)
        setMensaje("")
        setDatos([])
        try {
            let mInversionista = inversionista ? (inversionista.id || 0) : 0;
            const endpoint = esRetiros ? "reportes/retiros" : "reportes/ganancias";
            const body = esRetiros
                ? { inversionista: mInversionista, desde, hasta }
                : { inversionista: mInversionista, oficial: 0, desde, hasta };

            const respuesta = await axios.post(endpoint, body, {
                headers: { 'Content-Type': 'application/json' }
            });
            const data = respuesta.data;
            if (data.respuesta === "S") {
                if (data.data && data.data.length > 0) {
                    setDatos(data.data)
                } else {
                    setMensaje("No se encontraron registros en el rango seleccionado")
                }
            } else {
                setMensaje(data.mensaje || "Error al generar el reporte")
            }
        } catch (error) {
            console.log(error)
            setMensaje("Error de conexion al generar el reporte")
        }
        setCargando(false)
    }

    const columnsExport = datos.length > 0
        ? Object.keys(datos[0]).map(key => ({
            header: key.replace(/_/g, ' ').toUpperCase(),
            field: key,
            type: typeof datos[0][key] === 'number' && (key.toLowerCase().includes('monto') || key.toLowerCase().includes('ganancia') || key.toLowerCase().includes('capital')) ? 'money' : undefined
        }))
        : [];

    return (
        <Box sx={{
            minHeight: "100vh",
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            p: isMobile ? 1 : 2
        }}>
            <Paper sx={isMobile ? {
                width: '100%', maxWidth: '100%', minHeight: 'auto', padding: '16px', margin: 0,
                borderRadius: '12px', background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                boxShadow: '0 8px 32px rgba(30, 58, 95, 0.12)', border: '1px solid rgba(30, 58, 95, 0.1)', mb: 3
            } : { width: "500px", padding: "20px", mb: 3 }}>
                <Box sx={{
                    background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                    borderRadius: '8px 8px 0 0', borderBottom: '3px solid #d4af37',
                    mx: isMobile ? -2 : -2.5, mt: isMobile ? -2 : -2.5, mb: isMobile ? 2 : 3, p: isMobile ? 1.5 : 2
                }}>
                    <Typography variant={isMobile ? 'h6' : 'h5'}
                        sx={{ color: 'white', textAlign: 'center', fontWeight: 700, letterSpacing: 1 }}>
                        {titulo}
                    </Typography>
                </Box>

                <Box sx={{ mb: isMobile ? 2 : 3 }}>
                    <InversionistaFind2
                        value={inversionista} inputValue={inversionistaInput}
                        handleCambio={(value) => setInversionista(value)}
                        handleCambioInput={(value) => setInversionistaInput(value)}
                    />
                </Box>

                <Grid container spacing={isMobile ? 1.5 : 2}>
                    <Grid item xs={isMobile ? 6 : 12}>
                        <TextField fullWidth size={isMobile ? 'small' : 'medium'} type="date" label="Desde" value={desde}
                            onChange={(e) => setDesde(e.target.value)} InputLabelProps={{ shrink: true }}
                            sx={isMobile ? { '& .MuiInputBase-input': { fontSize: '0.85rem' } } : { marginBottom: "20px" }} />
                    </Grid>
                    <Grid item xs={isMobile ? 6 : 12}>
                        <TextField fullWidth size={isMobile ? 'small' : 'medium'} type="date" label="Hasta" value={hasta}
                            onChange={(e) => setHasta(e.target.value)} InputLabelProps={{ shrink: true }}
                            sx={isMobile ? { '& .MuiInputBase-input': { fontSize: '0.85rem' } } : { marginBottom: "20px" }} />
                    </Grid>
                </Grid>

                <Box sx={{ display: "flex", justifyContent: "center", mt: isMobile ? 3 : 2 }}>
                    <Button variant="contained" size={isMobile ? "large" : "medium"} onClick={handleClick}
                        fullWidth={isMobile} disabled={cargando}
                        sx={{
                            background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                            py: isMobile ? 1.5 : 1, fontWeight: 600,
                            '&:hover': { background: 'linear-gradient(135deg, #2c5282 0%, #3d6a9f 100%)' }
                        }}
                    >
                        {cargando ? <CircularProgress size={24} color="inherit" /> : "Generar reporte"}
                    </Button>
                </Box>
            </Paper>

            {mensaje && (
                <Typography sx={{ color: '#666', mb: 2 }}>{mensaje}</Typography>
            )}

            {datos.length > 0 && (
                <Paper sx={{ width: '100%', maxWidth: '1200px', p: 2, borderRadius: 2, boxShadow: 3 }}>
                    <ExportButtons data={datos} columns={columnsExport} filename={esRetiros ? "retiros" : "ganancias"} title={titulo} />
                    <TableContainer sx={{ maxHeight: 500 }}>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    {Object.keys(datos[0]).map(key => (
                                        <TableCell key={key} sx={{ fontWeight: 'bold', backgroundColor: '#1e3a5f', color: 'white', whiteSpace: 'nowrap' }}>
                                            {key.replace(/_/g, ' ').toUpperCase()}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {datos.map((row, i) => (
                                    <TableRow key={i} sx={{ '&:nth-of-type(even)': { backgroundColor: '#f5f7fa' } }}>
                                        {Object.values(row).map((val, j) => (
                                            <TableCell key={j} sx={{ whiteSpace: 'nowrap' }}>
                                                {typeof val === 'number' ? val.toLocaleString('en-US', { minimumFractionDigits: 2 }) : (val || '')}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Typography sx={{ mt: 1, color: '#666', fontSize: '0.85rem' }}>
                        Total registros: {datos.length}
                    </Typography>
                </Paper>
            )}
        </Box>
    )
}
